// itemService.js
import { API_CONFIG } from './../config'; 

const PUSH_APPITEMSUSE = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPITEMSUSEPUSH}`;

export const currentUserId = localStorage.getItem('userId');

export const ItemClick = async (option, userPhone, currentUserId) => {
  
  const formData = {
    userPhone: userPhone || currentUserId || 'No',
    name: option.name,
    type: option.id
  };

  try {
    await fetch(PUSH_APPITEMSUSE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
  } catch (error) {
    console.error('Submission error:', error.message);
  }
};